import has from 'lodash/has'

import { EMPTY_LIST } from '../../../../constants/common'
import { isApiConflictStatus } from '../../../../utils/api'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_FILES,
  EMAIL_CREATION_FORM_FIELD_NAME_FROM,
  EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE,
  EMAIL_CREATION_FORM_FIELD_NAME_SUBJECT,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
  getInputRecipientValue,
} from '../../../Email'
import {
  getApplicantFieldValue,
  getIsApplicantFieldMasked,
} from '../../../RentalPortalApplicant'

import {
  APPLICANT_PROFILE_EMAILS_NO_ADDRESS_REASON,
  APPLICANT_PROFILE_EMAILS_SEND_ERROR_FIELD,
} from './RentalPortalApplicantProfileEmails.constants'

function getHasApplicantProfileEmailsSendFieldError({ data, field }) {
  return has(data, field) || has(data?.errors, field)
}

function getIsApplicantProfileEmailsNoAddressReason(reason) {
  return reason === APPLICANT_PROFILE_EMAILS_NO_ADDRESS_REASON
}

function getIsApplicantProfileEmailsNoAddressError(error) {
  const reason = error?.response?.data?.meta?.reason

  return (
    isApiConflictStatus(error?.response?.status) &&
    getIsApplicantProfileEmailsNoAddressReason(reason)
  )
}

export function getIsApplicantProfileEmailsEmpty({ emails, isInitiated }) {
  return isInitiated && emails.length === 0
}

export function getApplicantProfileEmailsAddress(applicantData) {
  return getIsApplicantFieldMasked(applicantData?.identity)
    ? null
    : getApplicantFieldValue(applicantData?.email)
}

export function getHasApplicantProfileEmailsMailbox({ account, isLoading }) {
  return Boolean(account) || isLoading
}

export function getApplicantProfileEmailsComposeTooltipKey({
  applicantData,
  hasMailbox,
}) {
  if (getIsApplicantFieldMasked(applicantData?.identity)) {
    return 'RentalPortal.ApplicantProfileEmailsComposeMaskedTooltipKey'
  }

  if (!getApplicantProfileEmailsAddress(applicantData)) {
    return 'RentalPortal.ApplicantProfileEmailsComposeNoAddressTooltipKey'
  }

  return hasMailbox
    ? null
    : 'RentalPortal.ApplicantProfileEmailsComposeNoMailboxTooltipKey'
}

export function getApplicantProfileEmailsRecipients(applicantData) {
  const address = getApplicantProfileEmailsAddress(applicantData)

  return address ? [getInputRecipientValue(address)] : EMPTY_LIST
}

export function getApplicantProfileEmailsComposeInitialValues({
  applicantData,
  emailInitialValues,
}) {
  return {
    ...emailInitialValues,
    [EMAIL_CREATION_FORM_FIELD_NAME_TO]:
      getApplicantProfileEmailsRecipients(applicantData),
  }
}

export function getApplicantProfileEmailsSendPayload({ applicantId, payload }) {
  return {
    applicantId,
    hasFiles: payload?.[EMAIL_CREATION_FORM_FIELD_NAME_FILES]?.length > 0,
    subject: payload?.[EMAIL_CREATION_FORM_FIELD_NAME_SUBJECT],
    text: payload?.[EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE],
  }
}

export function toApplicantProfileEmailSendData(payload) {
  return {
    account: payload[EMAIL_CREATION_FORM_FIELD_NAME_FROM],
    files: payload[EMAIL_CREATION_FORM_FIELD_NAME_FILES],
    subject: payload[EMAIL_CREATION_FORM_FIELD_NAME_SUBJECT],
    text: payload[EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE],
  }
}

export function getIsApplicantProfileEmailMasked(email) {
  return getIsApplicantFieldMasked(email?.participant)
}

export function getApplicantProfileEmailsSendErrorKey(error) {
  const data = error?.response?.data

  if (
    getHasApplicantProfileEmailsSendFieldError({
      data,
      field: APPLICANT_PROFILE_EMAILS_SEND_ERROR_FIELD.account,
    })
  ) {
    return 'RentalPortal.ApplicantProfileEmailsSendAccountErrorKey'
  }

  if (
    getHasApplicantProfileEmailsSendFieldError({
      data,
      field: APPLICANT_PROFILE_EMAILS_SEND_ERROR_FIELD.files,
    })
  ) {
    return 'RentalPortal.ApplicantProfileEmailsSendFilesErrorKey'
  }

  return getIsApplicantProfileEmailsNoAddressError(error)
    ? 'RentalPortal.ApplicantProfileEmailsComposeNoAddressTooltipKey'
    : 'Error.CommonApiRequestFailKey'
}

export function toApplicantProfileEmailsSendError({ error, message }) {
  return {
    ...error,
    response: { ...error?.response, data: { errors: message } },
  }
}
